import { basicEnum } from "./base";

export const TimeZoneEnum = basicEnum([
    {
        label: "WIB",
        value: "Asia/Jakarta",
    },
    {
        label: "WITA",
        value: "Asia/Makassar",
    },
    {
        label: "WIT",
        value: "Asia/Jayapura",
    },
]);

export namespace TimeZoneEnum {
    export type Labels = (typeof TimeZoneEnum)["labels"][number];
    export type Values = (typeof TimeZoneEnum)["values"][number];
}
